import {PasswordInput} from 'react-admin';

const PasswordInputMod = props => {
    return (<PasswordInput {...props} />);
};

export default PasswordInputMod;